import TestReducer from './TestReducer';
import UndoReducer from './UndoReducer';
import PreviewReducer from './PreviewReducer';
import LoadingReducer from './LoadingReducer';

export default action => state => [TestReducer, UndoReducer, PreviewReducer, LoadingReducer].reduce((newState, r) => r(newState, action), state);
